<template>
  <div class="flex-1 flex">
    <UserAuthForm :submit-form="loginLocal" button-text="Login" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserAuthForm from '~/components/account/UserAuthForm.vue'

export default {
  middleware: 'guest',
  components: {
    UserAuthForm
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    async loginLocal (userInfo) {
      try {
        await this.$auth
          .loginWith('local', { data: userInfo })
          .then((response) => {
            this.$auth.setUser(response.data.user)
            this.$store.commit('user', response.data.user)
            this.$store.commit('authToken', response.data.user.token)
            this.$cookies.set('authToken', response.data.user.token)
            this.$router.push({ path: '/dashboard' })
          })
          .catch(() => {
            this.$toast.error('Either email or password is wrong. Please try again.')
          })
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
